import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {CalltoactionService} from '@irb/irb-common/components/calltoaction/calltoaction.service';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {ComExtAccountHoldingsGridLayoutService} from './com-ext-account-holdings.grid-layout.service';
import {UtilityService} from "@irb-common/services/utility.service";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {IPortfolioResultSecurity} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {DropdownSearchComponent} from "@irb-common/components/dropdown-search/dropdown-search.component";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
    selector: 'irb-com-external-accounts',
    templateUrl: './com-external-accounts.component.html',
    styleUrls: ['./com-external-accounts.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComExternalAccountsComponent implements OnInit {
    @ViewChild('irbTaxabilityDropdown') irbTaxabilityDropdown: DropdownFilterComponent;
    grid: any;
    gridOptions: any;
    _data: any = {};
    rowCount: any;
    selectedHolding: any;
    secDropdown: any = [];
    quantity: any;
    tooltipMessage: any;
    toolTipShow: boolean;
    selectedSymbolValue: any;
    @ViewChild("externalSecurityDropdown") externalSecurityDropdown: DropdownSearchComponent;
    @Output() change = new EventEmitter<boolean>();
    securitiesDropDownData: any = [];
    selectedTaxability: any;
    frameworkComponents: any;

  constructor(private gls:ComExtAccountHoldingsGridLayoutService,private ctas: CalltoactionService,private ies:IrbEditorsService, private utilService: UtilityService) {

        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),            
            floatingFilter: false,
            overlayNoRowsTemplate:
                "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No External Holdings Data</span>",
            context: {componentParent: this},
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
            suppressHorizontalScroll: true
        };

        this.frameworkComponents = this.gls.getFrameworkComponents();
    }

    ngOnInit() {

        this.toolTipShow = false;
        this.tooltipMessage = "";
        this.ies
            .getExtSecurityHoldings()
            .subscribe((data: any) => {
                this.securitiesDropDownData = data.items;
                this.loadSecuritiesDropDown(data.items);
            });
    }

    loadSecuritiesDropDown(items: any) {
        for (let i = 0; i < items.length; i++) {
            this.secDropdown.push(items[i]);
        }
        if (this.secDropdown && this.secDropdown.length > 0) {
            this.secDropdown = this.utilService.sortByKey(this.secDropdown, "securitySymbol", "asc");
        }
    }

    populateSecuritiesDropdown(searchString: any) {
        if (searchString && searchString.length > 0) {
            // this.externalSecurityDropdown.set(DropdownFilterComponent.getFilteredList(searchString, this.secDropdown));
            this.externalSecurityDropdown.set((this.secDropdown || [])
                .filter((security: IPortfolioResultSecurity) => security.securitySymbol &&
                    security.securitySymbol.toUpperCase().startsWith(searchString.toUpperCase()))
                .map((security: IPortfolioResultSecurity) => ({
                    name: security.securitySymbol,
                    value: security.securityId
                })));
        }
    }

    clearExternalSecurity() {
        delete this.selectedHolding;
        this.selectedSymbolValue = null;
        this.toolTipShow = false;
        this.tooltipMessage = "";
    }

    onExtHoldingChange(event: IDropdownItem) {
        this.toolTipShow = false;
        this.tooltipMessage = "";
        this.selectedHolding = {name: event.name, value: event.value};
    }

    addExternalHoldingsToGrid() {
        this.toolTipShow = false;
        this.tooltipMessage = "";
        //let extSharePrice = this.securitiesDropDownData.filter((sec: any) => sec.securityId === this.selectedHolding.value).extSharePrice;
        let securitySelected = this.securitiesDropDownData.filter((sec: any) => sec.securityId === this.selectedHolding.value);
        // console.log(this.securitiesDropDownData.filter((sec: any) => sec.securityId === this.selectedHolding.value));
        // do not add if the quantity is not a number of negative.
        if (isNaN(this.quantity) || this.quantity < 0) {
            return;
        }
        if (!this.data.extAcctHoldingsList.some((x: any) => x.extSymbol === this.selectedHolding.name)) {
            let extHolding =
                {
                    accountId: this.data.accountId,
                    extSymbol: this.selectedHolding.name,
                    extSymbolId: this.selectedHolding.value,
                    shareQty: this.quantity,
                    extSharePrice: securitySelected[0].extSharePrice,
                    securityType: securitySelected[0].securityType,
                    isUIdeleted: false,
                    isNew: true
                }
            if (this.data.extAcctHoldingsList) {
                this.data.extAcctHoldingsList.push(extHolding);
            } else {
                this.data.extAcctHoldingsList = extHolding;
            }
            this.clearExternalSecurity();
            if (this.externalSecurityDropdown?.inputControl) {
                this.externalSecurityDropdown.value = null;
                this.externalSecurityDropdown.inputControl.setValue(null);
            }
            this.quantity = null;
            this.loadGrid();
            this.change.emit(true);
        } else {
            let externalHolding = this.data.extAcctHoldingsList.find((x: any) => x.extSymbol === this.selectedHolding.name);
            if (externalHolding && externalHolding.isUIdeleted) {
                externalHolding.shareQty = this.quantity;
                externalHolding.isUIdeleted = false;
                this.clearExternalSecurity();
                if (this.externalSecurityDropdown?.inputControl) {
                    this.externalSecurityDropdown.inputControl.setValue(null);
                }
                this.quantity = null;
                this.loadGrid();
                this.change.emit(true);
            } else {
                this.toolTipShow = true;
                this.tooltipMessage = "Please select a different security";
            }
        }
    }

    getTaxabilityItems() {
        let items = [
            {name: "TAXABLE", value: "TAXABLE"},
            {name: "DEFERRED", value: "DEFERRED"},
            {name: "ROTH", value: "ROTH"}
        ];
        const f: Array<IDropdownItem> = [].concat(items);
        this.irbTaxabilityDropdown.set(f);
    }

    mapSharePrice(params: any) {
        console.log(params);

    }

    onTaxabilityChange(item: IDropdownItem) {
        this.data.accountLocationType = item.value;
        this.change.emit(true);
    }

    onGridReady(params: any) {
        this.grid = params;
        this.loadGrid();
    }

    loadGrid() {
        if (this.data.extAcctHoldingsList && this.grid) {
            this.grid.api.setGridOption('rowData', this.data.extAcctHoldingsList);
            this.rowCount = this.getRowCount();
        }
    }

    deleteAll() {
        this.tooltipMessage = "";
        this.toolTipShow = false;
        for (let i = 0; i < this.data.extAcctHoldingsList.length; i++) {
            if (this.data.extAcctHoldingsList[i].isNew) {
                this.data.extAcctHoldingsList.splice(i--, 1);
            } else {
                this.data.extAcctHoldingsList[i].isUIdeleted = true;
            }
        }

        this.loadGrid();
        this.change.emit(true);
    }

    delete(cc: any) {
        this.tooltipMessage = "";
        this.toolTipShow = false;
        for (let i = 0; i < this.data.extAcctHoldingsList.length; i++) {
            if (this.data.extAcctHoldingsList[i].extSymbolId === cc.extSymbolId) {
                if (this.data.extAcctHoldingsList[i].isNew) {
                    this.data.extAcctHoldingsList.splice(i--, 1);
                } else {
                    this.data.extAcctHoldingsList[i].isUIdeleted = true;
                }
                break;
            }
        }

        this.loadGrid();
        this.change.emit(true);
    }

    cancelDelete() {
        this.ctas.remove();
    }

    getRowCount() {
        return this.data.extAcctHoldingsList ? this.data.extAcctHoldingsList.filter((x: any) => x.isUIdeleted === false).length : 0;
    }

    isExternalFilterPresent() {
        return true;
    }

    doesExternalFilterPass(node: any) {
        return !node.data.isUIdeleted;
    }

    @Input()
    get data(): any {
        return this._data;
    }

    set data(d: any) {
        this._data = d;
        // remove the tooltips messages if any.
        this.clearExternalSecurity();
        this.quantity = null;
        this.selectedTaxability = null;
        if (this.externalSecurityDropdown?.inputControl) {
            this.externalSecurityDropdown.inputControl.setValue(null);
        }
        if (this.data?.accountLocationType) {
            this.selectedTaxability = {name: this.data.accountLocationType, value: this.data.accountLocationType};
        }
    }

    isValidSelections() {
        let isValidSelection = (this.selectedHolding && this.selectedHolding.value > 0) && this.quantity >= 0;
        return isValidSelection;
    }

}
